import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LogIn04 = function LogIn04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m12 8 4 4m0 0-4 4m4-4H3m.3378-5C5.0668 4.011 8.2986 2 12 2c5.5228 0 10 4.4772 10 10s-4.4772 10-10 10c-3.7014 0-6.9331-2.011-8.6622-5"
    })
  }));
};
export default LogIn04;